module.exports = __webpack_public_path__ + "img/template-watch.505e0da7.png";